/**
 * Number formatting method for localization of job title data.
 * @param value
 * @param {string} locale - The locale to be used for formatting in language-country format. Inferred from WP site's name and passed as HI tag in HTML.
 * @param {string} style - The type of formatting to be used.
 * @param decimalsPoints
 * @param {string} currency - The currency in ISO 4217 format, this is dynamically resolved in frontend using `locale-currency` npm library
 * @returns {string} - The formatted number.
 */
const i18nNumberFormat = (
  value: number,
  locale: string = 'en-US', // default to en-US
  style: 'currency' | 'decimal' | 'percent' = 'decimal', // default to decimal
  decimalsPoints: number = 0,
  currency?: string
): string => {
  let options;
  if (style == 'currency') {
    options = {
      style,
      currency,
      maximumFractionDigits: decimalsPoints,
    };
  } else {
    options = {
      style,
      maximumFractionDigits: decimalsPoints,
    };
  }

  return Intl.NumberFormat(locale, options).format(value);
};

const i18nDateFormat = (
  dateString: string, // Tested with "June 2024" format
  locale: string = 'en-US'
): string => {
  const options: Intl.DateTimeFormatOptions = {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  };
  return new Date(dateString).toLocaleDateString(locale, options);
};

// replaces [month] in ACF with formated month
function replaceMonthPlaceholder(stringFromACF: string, formatedMonth: string) {
  return stringFromACF.replace('[month]', formatedMonth);
}

export { i18nNumberFormat, i18nDateFormat, replaceMonthPlaceholder };
